import { gql } from "@apollo/client";
import { SubCategoryEntityResponseCollection } from "../../gql-types";
export const subCategoriesNameListByCategoryNameGql = gql`
  query SubCategoriesNameListByCategoryName($catName: String!) {
    subCategories(filters: { category: { slug: { eq: $catName } } }) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

export const subCategoriesNameListByCategoryId = gql`
  query SubCategoriesNameListByCategoryName($catId: ID!) {
    subCategories(filters: { category: { id: { eq: $catId } } }) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

export const parser = (
  collection?: SubCategoryEntityResponseCollection,
): { id: string; name: string }[] => {
  if (!collection) {
    return [];
  }

  return collection.data.map((item) => {
    return {
      id: item.id ?? "",
      name: item.attributes?.name ?? "",
    };
  });
};
